import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'vi-program-item',
  templateUrl: 'program-item.component.html',
  styleUrls: ['program-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViProgramItemComponent {
  @Input() program: string;
  @Input() hasTemperature: boolean;
  @Input() displayProgramTile = true;
}
